import find from 'lodash/find';

import {
  FETCH_NOTIFICATION_SETTINGS_REQUEST,
  FETCH_NOTIFICATION_SETTINGS_SUCCESS,
  FETCH_NOTIFICATION_SETTINGS_FAILURE,
  CREATE_NOTIFICATION_SETTING_SUCCESS,
  DELETE_NOTIFICATION_SETTING_SUCCESS
} from '../const/action_types.js';

import {
  get as getUser
} from 'zoomforth_zf/appglobals/user.js';

import {
  error as showErrorNotification,
  success as showSuccessNotification
} from 'zoomforth_app_basics/action_creators/notifications.js';

import {
  getNotificationSettingsById
} from 'zoomforth_shared_management/reducers/index.js';

import {
  serializeQueryParams,
  sendRequestWithPromise
} from 'zoomforth_zfutils/xhr_tools.js';

import {
  NOTIFICATIONS_SETTINGS_ROUTE_VISIT_EVENT_TYPE,
  NOTIFICATIONS_SETTINGS_APPROVAL_REQUEST_EVENT_TYPE,
  NOTIFICATIONS_SETTINGS_SITE_ASSIGNMENT_EVENT_TYPE,
  NOTIFICATIONS_SETTINGS_ACCESS_REQUEST_EVENT_TYPE,
  NOTIFICATIONS_SETTINGS_FORM_RESPONSE_EVENT_TYPE 
} from '../const/notification_settings_event_types.js';


export const fetchNotificationSettingsRequest = ()=> {
  return { type: FETCH_NOTIFICATION_SETTINGS_REQUEST };
};

export const fetchNotificationSettingsSuccess = (data)=>{
  return { type: FETCH_NOTIFICATION_SETTINGS_SUCCESS, data };
};

export const fetchNotificationSettingsFailure = ()=>{
  return { type: FETCH_NOTIFICATION_SETTINGS_FAILURE };
};

export const fetchNotificationSettings = (userId)=>
  (dispatch)=> {
    dispatch(fetchNotificationSettingsRequest());

    const params = serializeQueryParams({
      user_id: userId
    });

    return sendRequestWithPromise({ 
      method: 'GET', 
      url: `/api/notification_settings?${params}`
    })
      .then((data)=> {
        dispatch(fetchNotificationSettingsSuccess(data));
      })
      .catch((status, message)=> {
        dispatch(fetchNotificationSettingsFailure(status, message));
      });
  };


export const fetchNotificationSettingsForCurrentUser = ()=>
  (dispatch)=> {
    dispatch(fetchNotificationSettings(getUser().id));
  };

export const createNotificationSettingSuccess = (objectId, eventType, data)=> {
  return {
    type: CREATE_NOTIFICATION_SETTING_SUCCESS,
    eventType,
    objectId,
    data
  };
};

export const createNotificationSetting = (objectId, eventType, userId)=>
  (dispatch)=> {
    sendRequestWithPromise({ 
      method:'POST', 
      url: '/api/notification_settings',
      params: { 
        event_type: eventType, 
        object_id: objectId,
        user_id: userId
      }
    })
      .then((data)=> {
        const message = (
          eventType === NOTIFICATIONS_SETTINGS_ROUTE_VISIT_EVENT_TYPE ?
            'You are subscribed to link visit notifications for this link'
          : eventType === NOTIFICATIONS_SETTINGS_ACCESS_REQUEST_EVENT_TYPE ?
            'You are subscribed to site access request notifications for this site'
          : eventType === NOTIFICATIONS_SETTINGS_SITE_ASSIGNMENT_EVENT_TYPE ?
            'You are subscribed to site assignment notifications for this site'
          : eventType === NOTIFICATIONS_SETTINGS_APPROVAL_REQUEST_EVENT_TYPE ?
            'You are subscribed to site approval request notifications for this site'
          : eventType === NOTIFICATIONS_SETTINGS_FORM_RESPONSE_EVENT_TYPE ?
            'You are subscribed to form response notifications for this form'
          :
            'Subscribed to notifications' // this technically won't happen but is safe
        );

        dispatch(showSuccessNotification({ message }));
        dispatch(createNotificationSettingSuccess(objectId, eventType, data));
      })
      .catch((status, xhr)=> {
        dispatch(showErrorNotification({ message: xhr.responseText }));
      });
  };

export const createNotificationSettingForCurrentUser = (objectId, eventType)=>
  (dispatch)=> {
    dispatch(createNotificationSetting(objectId, eventType, getUser().id));
  };

export const deleteNotificationSettingSuccess = (notificationSettingId)=> {
  return {
    type: DELETE_NOTIFICATION_SETTING_SUCCESS,
    notificationSettingId
  };
};

export const deleteNotificationSetting = (objectId, eventType, userId)=>
  (dispatch, getState)=> {
    const notificationSetting = find(
      getNotificationSettingsById(getState()), {
        object_id: objectId,
        user_id: userId,
        event_type: eventType
      }
    );

    if (!notificationSetting) {
      throw Error('Could not find a notification setting with those params');
    }

    sendRequestWithPromise({ 
      method: 'DELETE', 
      url: `/api/notification_settings/${notificationSetting.id}`
    })
      .then(()=> {
        const message = (
          eventType === NOTIFICATIONS_SETTINGS_ROUTE_VISIT_EVENT_TYPE ?
            'You are unsubscribed from link visit notifications for this link'
          : eventType === NOTIFICATIONS_SETTINGS_ACCESS_REQUEST_EVENT_TYPE ?
            'You are unsubscribed from site access request notifications for this site'
          : eventType === NOTIFICATIONS_SETTINGS_SITE_ASSIGNMENT_EVENT_TYPE ?
            'You are unsubscribed from site assignment notifications for this site'
          : eventType === NOTIFICATIONS_SETTINGS_APPROVAL_REQUEST_EVENT_TYPE ?
            'You are unsubscribed from site approval request notifications for this site'
          : eventType === NOTIFICATIONS_SETTINGS_FORM_RESPONSE_EVENT_TYPE ?
            'You are unsubscribed from form response notifications for this form'
          :
            'Unsubscribed from notifications' // this technically won't happen but is safe
        );

        dispatch(showSuccessNotification({ message }));
        dispatch(deleteNotificationSettingSuccess(notificationSetting.id));
      })
      .catch((status, xhr)=> {
        dispatch(showErrorNotification({ message: xhr.responseText }));
      });
  };

export const deleteNotificationSettingForCurrentUser = (objectId, eventType)=>
  (dispatch)=> {
    dispatch(deleteNotificationSetting(objectId, eventType, getUser().id));
  };

export const subscribeCurrentUserToRouteVisits = (routeId)=>
  (dispatch)=> {
    dispatch(createNotificationSettingForCurrentUser(
      routeId,
      NOTIFICATIONS_SETTINGS_ROUTE_VISIT_EVENT_TYPE
    ));
  };

export const subscribeCurrentUserToSiteApprovalRequests = (siteId)=>
  (dispatch)=> {
    dispatch(createNotificationSettingForCurrentUser(
      siteId,
      NOTIFICATIONS_SETTINGS_APPROVAL_REQUEST_EVENT_TYPE
    ));
  };

export const subscribeCurrentUserToSiteAssignmentRequests = (siteId)=>
  (dispatch)=> {
    dispatch(createNotificationSettingForCurrentUser(
      siteId,
      NOTIFICATIONS_SETTINGS_SITE_ASSIGNMENT_EVENT_TYPE
    ));
  };

export const subscribeCurrentUserToSiteAccessRequests = (siteId)=>
  (dispatch)=> {
    dispatch(createNotificationSettingForCurrentUser(
      siteId,
      NOTIFICATIONS_SETTINGS_ACCESS_REQUEST_EVENT_TYPE
    ));
  };

export const subscribeCurrentUserToFormResponses = (formId)=>
  (dispatch)=> {
    dispatch(createNotificationSettingForCurrentUser(
      formId,
      NOTIFICATIONS_SETTINGS_FORM_RESPONSE_EVENT_TYPE
    ));
  };

export const unsubscribeCurrentUserFromRouteVisits = (routeId)=>
  (dispatch)=> {
    dispatch(deleteNotificationSettingForCurrentUser(
      routeId,
      NOTIFICATIONS_SETTINGS_ROUTE_VISIT_EVENT_TYPE
    ));
  };

export const unsubscribeCurrentUserFromSiteApprovalRequests = (siteId)=>
  (dispatch)=> {
    dispatch(deleteNotificationSettingForCurrentUser(
      siteId,
      NOTIFICATIONS_SETTINGS_APPROVAL_REQUEST_EVENT_TYPE
    ));
  };

export const unsubscribeCurrentUserFromSiteAssignmentRequests = (siteId)=>
  (dispatch)=> {
    dispatch(deleteNotificationSettingForCurrentUser(
      siteId,
      NOTIFICATIONS_SETTINGS_SITE_ASSIGNMENT_EVENT_TYPE
    ));
  };

export const unsubscribeCurrentUserFromSiteAccessRequests = (siteId)=>
  (dispatch)=> {
    dispatch(deleteNotificationSettingForCurrentUser(
      siteId,
      NOTIFICATIONS_SETTINGS_ACCESS_REQUEST_EVENT_TYPE
    ));
  };

export const unsubscribeCurrentUserFromFormResponses = (formId)=>
  (dispatch)=> {
    dispatch(deleteNotificationSettingForCurrentUser(
      formId,
      NOTIFICATIONS_SETTINGS_FORM_RESPONSE_EVENT_TYPE
    ));
  };
